import { RefObject, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { CrashReport, acknowledgeCrash, crashReportOf } from '../services/crashReport';

export interface ReceivedCrash {
  id: number;
  report: CrashReport;
}

export function useCrashReport(
  frame: RefObject<HTMLIFrameElement>,
  gameUrl: string,
): [crash: ReceivedCrash | null, dismiss: () => void] {
  const [crash, setCrash] = useState<ReceivedCrash | null>(null);
  const lastId = useRef(0);
  const origin = useMemo(() => originOf(gameUrl), [gameUrl]);

  useEffect(() => {
    if (!origin) return;
    const receive = (event: MessageEvent) => {
      const game = frame.current?.contentWindow ?? null;
      const report = crashReportOf(event, game, origin);
      if (!report || !game) return;
      acknowledgeCrash(game, origin);
      lastId.current += 1;
      setCrash({ id: lastId.current, report });
    };
    window.addEventListener('message', receive);
    return () => window.removeEventListener('message', receive);
  }, [frame, origin]);

  const dismiss = useCallback(() => setCrash(null), []);
  return [crash, dismiss];
}

function originOf(url: string): string | null {
  try {
    return url ? new URL(url).origin : null;
  } catch {
    return null;
  }
}
